<div class="import-page">
  @if (space) {
    <div class="import-card">
      <div class="import-header">
        <svg class="import-icon" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
          <polyline points="7 10 12 15 17 10"/>
          <line x1="12" y1="15" x2="12" y2="3"/>
        </svg>
        <h1>Import Space</h1>
        <p class="subtitle">Someone shared a space with you</p>
      </div>
      <div class="space-preview">
        <h2>{{ space.name }}</h2>
        <div class="preview-details">
          <div class="detail-row">
            <span class="label">Country:</span>
            <span class="value">{{ space.country }}</span>
          </div>
          <div class="detail-row">
            <span class="label">Owner:</span>
            <span class="value">{{ space.ownerName }}</span>
          </div>
          <div class="detail-row">
            <span class="label">Industries:</span>
            <span class="value">{{ space.relevantIndustries.length > 0 ? space.relevantIndustries.join(', ') : 'None selected' }}</span>
          </div>
          <div class="detail-row">
            <span class="label">Team Size:</span>
            <span class="value">{{ space.teamSize }} people</span>
          </div>
          @if (space.notes.length > 0) {
            <div class="detail-row">
              <span class="label">Notes:</span>
              <span class="value">{{ space.notes.length }} note(s)</span>
            </div>
          }
        </div>
        @if (alreadyExists) {
          <div class="exists-warning">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/>
              <path d="M12 9v4"/>
              <path d="M12 17h.01"/>
            </svg>
            <span>A space with this name already exists. Importing will create a copy with a new name.</span>
          </div>
        }
      </div>
      <div class="import-actions">
        <button class="btn-cancel" (click)="cancel()" [disabled]="importing">Cancel</button>
        <button class="btn-import" (click)="importSpace()" [disabled]="importing">
          {{ importing ? 'Importing...' : 'Import Space' }}
        </button>
      </div>
    </div>
  } @else {
    <div class="import-card error-card">
      <div class="import-header">
        <svg class="error-icon" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <path d="m15 9-6 6"/>
          <path d="m9 9 6 6"/>
        </svg>
        <h1>Import Failed</h1>
        <p class="subtitle error-text">{{ error }}</p>
      </div>
      <div class="import-actions">
        <button class="btn-cancel" (click)="cancel()">Go to Spaces</button>
      </div>
    </div>
  }

</div>
